import { HTTP } from "./http";

const ENDPOINT_LOCATIONS = "resources/provinces";

export default {
  getLocations() {
    return new Promise((resolve, reject) => {
      HTTP.get(ENDPOINT_LOCATIONS)
        .then(function(response) {
          resolve(response.data);
        })
        .catch(function(error) {
          reject(error);
        });
    });
  },
};
